/**
 * セット企画設定画面　入力VOクラス
 */
export class KYMW1312InputModel {
  /** 処理区分(1：セット企画設定、2：セット企画追加) */
  public accessDiv: string = null;
  /** 編集ロック(true：ロック取得、false：ロック解除) */
  public editLock: boolean = <boolean>false;
  /** 受注コード */
  public orderCode: string = null;
  /** プロモーションＮＯ */
  public promotionNo: string = null;
  /** プロモーション名称 */
  public promotionName: string = null;
  /** Ｐコードリスト */
  public pCodeList: Array<any> = new Array<any>();
  /** 媒体グループ区分が通常媒体か */
  public isGroupNormal = false;

  /**
   * 起動タイプ
   * 【既にポップアップが表示されていた場合】0:最前列に移動する 1:再度開く 2:閉じる
   */
  public openType = Number(0);
  /** 編集済みカウンタ */
  public editCount = Number(0);
}
